/**
 * 增加版本号用 年入月时分202101261844
 * @param formatter
 * @param date
 * @returns
 */
function dateFormat(formatter: string, date: Date) {
  let fmt = formatter;
  let ret;
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    // 'S+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  // eslint-disable-next-line guard-for-in
  for (const key in opt) {
    const k = key as keyof typeof opt;
    ret = new RegExp('(' + k + ')').exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
      );
    }
  }
  return fmt;
}

export function generateVersion() {
  const version = '.' + dateFormat('YYYYmmddHHMM', new Date());
  return version;
}
